// todo: need unit test
import { DataDefinition } from "./Data/DataDefinition";
import { IDataDefinition } from "./Data/Definitions/IDataDefinition";

export class DataDefinitionUtilities {
    static TYPE_FIELD_NAME: string = "__type";

    static getDataDefinitionFromData(data: object): IDataDefinition | undefined {
        if (!data) return;

        let typeName = Reflect.get(data, this.TYPE_FIELD_NAME);

        if (typeName) {
            let registeredControl = DataDefinition.TYPEMAP[typeName];
            let prototype = Object.getPrototypeOf(registeredControl);
            let val = new prototype.constructor();
            // @ts-ignore
            let cc = val as IDataDefinition;

            cc.setStorageData(data);

            return cc;
        }

        throw new Error("Could not create data definition: no type defined: " + typeName);
    }

    static verifyTypeField(d: object) {
        if (!Reflect.get(d, this.TYPE_FIELD_NAME)) throw new Error("missing type field");
    }
}
